import { useSelector } from "react-redux";
import useSubscribe from "../../../../../custom-hooks/useSubscribe";
import { State } from "../../../../../selectors/state";
import { valuesOf } from "../../../../../shared-functions/objects";
import { ValidOpenstackResource } from "../../../../types";

const useGetCurrentNetwork = (networkId?: string) => {
  useSubscribe("NETWORKS_LIST");

  const networks = useSelector((state: State) => state.networks);

  // No network ID provided —> no need to look for a network
  if (!networkId)
    return { selectedNetwork: undefined, isLoadingNetworks: false };

  const selectedNetwork: ValidOpenstackResource | undefined = valuesOf(
    networks.NETWORKS_LIST,
  ).find((item) => item.id === networkId);

  if (selectedNetwork) {
    return { selectedNetwork, isLoadingNetworks: false };
  }

  const isLoading = networks.NETWORKS_LIST_LOADING_ZONES_LEFT > 0;
  return { selectedNetwork, isLoadingNetworks: isLoading };
};

export default useGetCurrentNetwork;
